import React, {useMemo} from "react";
import {Interpolation, Theme} from "@emotion/react";

import {propertyListSortOptions} from "../../../property/constants/property_list_sort_options";
import {SortOptions} from "../../detail/components/sort/SortOptions";
import {SortOptionsValues} from "../../detail/types/SortOptionsValues";
import {FakeSelectWithModal} from "./FakeSelectWithModal";
import {SelectLabelWithEllipsis} from "./SelectLabelWithEllipsis";

interface IProps {
    rightDropdown?: boolean;
    onConfirm?: (value: IFilterValue) => void;
    onClear?: () => void;
    onRemove?: () => void;
    aplaCss?: Interpolation<Theme>;
    onDropdownOpen?: () => void;
    onDropdownClose?: () => void;
    sortValue: SortOptionsValues;
    setSortValue: React.Dispatch<React.SetStateAction<SortOptionsValues>>;
    className?: string;
}

type IFilterValue = SortOptionsValues;
const emptyValue: IFilterValue = SortOptionsValues.NOT_SELECTED;

export const OfferPropertiesSort = (props: IProps) => {
    const {sortValue, setSortValue, onConfirm, onRemove, onClear, rightDropdown, className} = props;
    const {label} = useMemo(() => {
        const selectedOption = propertyListSortOptions.find((option) => option.value === sortValue);
        const showSubLabel = !!sortValue;

        return {
            selectedOption,
            label: <SelectLabelWithEllipsis label="Sortuj" subLabel={selectedOption?.label} showSubLabel={showSubLabel} />
        };
    }, [sortValue]);

    const handlers = {
        confirm: () => {
            onConfirm?.(sortValue);
        },
        clear: () => {
            setSortValue(emptyValue);
            onClear?.();
        },
        remove: () => {
            setSortValue(emptyValue);
            onRemove?.();
        }
    };

    const handleDropdownClose = () => {
        onConfirm?.(sortValue);
        props.onDropdownClose?.();
    };

    return (
        <FakeSelectWithModal
            rightDropdown={rightDropdown}
            label={label}
            isEmpty={!sortValue}
            onClear={handlers.clear}
            onDropdownOpen={props.onDropdownOpen}
            onDropdownClose={handleDropdownClose}
            aplaCss={props.aplaCss}
            className={className}
        >
            {(props) => (
                <>
                    <SortOptions<IFilterValue>
                        currentValue={sortValue}
                        setCurrentValue={setSortValue}
                        sortOptions={propertyListSortOptions}
                        onCancel={() => {
                            props.close();
                            handlers.clear();
                        }}
                        onSave={() => {
                            props.close();
                            handlers.confirm();
                        }}
                    />
                </>
            )}
        </FakeSelectWithModal>
    );
};
import React, {useMemo} from "react";
import {Interpolation, Theme} from "@emotion/react";

import {propertyListSortOptions} from "../../../property/constants/property_list_sort_options";
import {SortOptions} from "../../detail/components/sort/SortOptions";
import {SortOptionsValues} from "../../detail/types/SortOptionsValues";
import {FakeSelectWithModal} from "./FakeSelectWithModal";
import {SelectLabelWithEllipsis} from "./SelectLabelWithEllipsis";

interface IProps {
    rightDropdown?: boolean;
    onConfirm?: (value: IFilterValue) => void;
    onClear?: () => void;
    onRemove?: () => void;
    aplaCss?: Interpolation<Theme>;
    onDropdownOpen?: () => void;
    onDropdownClose?: () => void;
    sortValue: SortOptionsValues;
    setSortValue: React.Dispatch<React.SetStateAction<SortOptionsValues>>;
    className?: string;
}

type IFilterValue = SortOptionsValues;
const emptyValue: IFilterValue = SortOptionsValues.NOT_SELECTED;

export const OfferPropertiesSort = (props: IProps) => {
    const {sortValue, setSortValue, onConfirm, onRemove, onClear, rightDropdown, className} = props;
    const {label} = useMemo(() => {
        const selectedOption = propertyListSortOptions.find((option) => option.value === sortValue);
        const showSubLabel = !!sortValue;

        return {
            selectedOption,
            label: <SelectLabelWithEllipsis label="Sortuj" subLabel={selectedOption?.label} showSubLabel={showSubLabel} />
        };
    }, [sortValue]);

    const handlers = {
        confirm: () => {
            onConfirm?.(sortValue);
        },
        clear: () => {
            setSortValue(emptyValue);
            onClear?.();
        },
        remove: () => {
            setSortValue(emptyValue);
            onRemove?.();
        }
    };

    const handleDropdownClose = () => {
        onConfirm?.(sortValue);
        props.onDropdownClose?.();
    };

    return (
        <FakeSelectWithModal
            rightDropdown={rightDropdown}
            label={label}
            isEmpty={!sortValue}
            onClear={handlers.clear}
            onDropdownOpen={props.onDropdownOpen}
            onDropdownClose={handleDropdownClose}
            aplaCss={props.aplaCss}
            className={className}
        >
            {(props) => (
                <>
                    <SortOptions<IFilterValue>
                        currentValue={sortValue}
                        setCurrentValue={setSortValue}
                        sortOptions={propertyListSortOptions}
                        onCancel={() => {
                            props.close();
                            handlers.clear();
                        }}
                        onSave={() => {
                            props.close();
                            handlers.confirm();
                        }}
                    />
                </>
            )}
        </FakeSelectWithModal>
    );
};
